<template>
  <div :class="['success-card', estadoClass]">
    <b-row align-v="center">
      <b-col cols="10">
        <div class="d-flex align-items-center">
          <img
            alt="status"
            width="32px"
            :src="iconoEstado"
            class="mr-3"
          >
          <div>
            <h6 class="mb-0 titulo-success">{{ titulo }}</h6>
            <small class="subtitulo-success">{{ subtitulo }}</small>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'EstadoCarga',
  props: {
    filasConError: {
      type: Number,
      default: 0
    },
    esInicial: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    estadoClass() {
      if (this.esInicial) return 'bg-neutral';
      return this.filasConError > 0 ? 'bg-warning-gradient' : '';
    },
    iconoEstado() {
      if (this.esInicial) return require('@/assets/icons/info_relleno_azul.svg');
      return this.filasConError > 0
        ? require('@/assets/icons/info_relleno_azul.svg')
        : require('@/assets/icons/check-green.svg');
    },
    titulo() {
      if (this.esInicial) return 'Listo para procesar';
      return this.filasConError > 0
        ? 'Carga procesada con algunas observaciones'
        : 'Carga procesada correctamente';
    },
    subtitulo() {
      if (this.esInicial) return 'Ve a la pestaña "Cargar archivos" para procesar un archivo';
      return this.filasConError > 0
        ? 'Revisa los detalles en la tabla inferior'
        : 'Los registros válidos han sido actualizados en el sistema';
    }
  }
}
</script>

<style scoped>
.success-card {
  background: linear-gradient(135deg, #d4edda 0%, #c5e29b 100%);
  border-radius: 12px;
  padding: 1rem 1.5rem;
  border: 1px solid #c3e6cb;
}

.bg-neutral {
  background: linear-gradient(135deg, #e9ecef 0%, #dee2e6 100%) !important;
  border: 1px solid #ced4da !important;
}

.bg-neutral .titulo-success {
  color: #495057;
}

.bg-neutral .subtitulo-success {
  color: #343a40;
}

.bg-warning-gradient {
  background: linear-gradient(135deg, #fff3cd 0%, #ffeeba 100%) !important;
  border: 1px solid #ffeeba !important;
}

.titulo-success {
  color: #155724;
  font-weight: 700;
  font-size: 15px;
}

.bg-warning-gradient .titulo-success {
  color: #856404;
}

.subtitulo-success {
  color: #1b5e20;
  font-size: 12.5px;
  opacity: 0.8;
}

.bg-warning-gradient .subtitulo-success {
  color: #856404;
}
</style>